import { z } from 'zod';
import { programSchema } from './team.ts';

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
  }),
});
export type ApiError = z.infer<typeof apiErrorSchema>;

export const paginationQuerySchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});
export type PaginationQuery = z.infer<typeof paginationQuerySchema>;

export const teamQuerySchema = paginationQuerySchema.extend({
  program: programSchema.optional(),
  country: z.string().optional(),
  region: z.string().optional(),
  city: z.string().optional(),
  division: z.string().optional(),
  event: z.string().optional(),
  hasStory: z.enum(['true', 'false']).optional(),
});
export type TeamQuery = z.infer<typeof teamQuerySchema>;

export const searchQuerySchema = z.object({
  q: z.string().min(1).max(100),
  limit: z.coerce.number().int().min(1).max(50).default(20),
});
export type SearchQuery = z.infer<typeof searchQuerySchema>;

export const searchResultSchema = z.object({
  type: z.enum(['team', 'city', 'country']),
  label: z.string(),
  sublabel: z.string().nullable(),
  href: z.string(),
  score: z.number(),
  meta: z.record(z.string(), z.string().or(z.number())).optional(),
});
export type SearchResult = z.infer<typeof searchResultSchema>;

export const syncRunSchema = z.object({
  id: z.uuid(),
  job: z.string(),
  startedAt: z.iso.datetime(),
  finishedAt: z.iso.datetime().nullable(),
  ok: z.boolean(),
  processed: z.number().int(),
  errors: z.number().int(),
  message: z.string().nullable(),
});
export type SyncRun = z.infer<typeof syncRunSchema>;

export const healthSchema = z.object({
  ok: z.literal(true),
  sha: z.string(),
  ts: z.iso.datetime(),
  lastSyncedAt: z.iso.datetime().nullable(),
});
export type Health = z.infer<typeof healthSchema>;
